<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div class="col-md-12">
          <div
            class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
            style="min-height: 5vh"
          >
            <div style="color: #28293d" class="px-3 pb-2">
              <button @click="$router.back()" class="btn">
                <font-awesome-icon
                  icon="fa-solid fa-arrow-left"
                  style="color: #28293d"
                />
              </button>
              Edit Profile
            </div>
            <div
              class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
              style="min-height: 60vh"
            >
              <div class="container p-4">
                <div
                  v-if="
                    changesInformation.kontraktorId != null &&
                    String(
                      changesInformation.statusChanges || '',
                    ).toLowerCase() === 'rejected'
                  "
                  class="d-flex align-items-start p-3 mb-4 text-dark bg-danger bg-gradient rounded shadow-sm"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-circle-exclamation"
                    class="me-2 fs-2 flex-shrink-0 mt-1"
                    style="color: #eeecec"
                  />
                  <div class="lh-sm text-white">
                    <h2 class="h6 mb-2 fw-bold">
                      Pengajuan perubahan profil ditolak
                    </h2>
                    <p class="mb-2 fs-8 opacity-90">
                      Form di bawah menampilkan data dari pengajuan terakhir
                      yang ditolak. Silakan perbaiki lalu simpan kembali.
                    </p>
                    <p
                      v-if="
                        changesInformation.reason != null &&
                        String(changesInformation.reason).trim() !== ''
                      "
                      class="mb-0 fs-8 border-top border-white border-opacity-25 pt-2"
                    >
                      <span class="fw-bold">Alasan penolakan:</span>
                      {{ changesInformation.reason }}
                    </p>
                  </div>
                </div>
                <!-- form di sini -->
                <form action="#" @submit.prevent="preventSubmit">
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <p class="text-danger fst-italic fs-8 fw-bold">
                        * Wajib diisi
                      </p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label
                        for="namaKontraktor"
                        class="form-label fs-8 fw-bold"
                        >Nama Kontraktor
                        <span class="text-danger fs-6">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="namaKontraktor"
                        placeholder="Masukkan Nama Kontraktor"
                        v-model="formValues.namaKontraktor"
                      />
                    </div>
                    <div class="col-md-5">
                      <label for="fileLogo" class="form-label fs-8 fw-bold"
                        >Logo (png, jpg, jpeg)</label
                      >
                      <div class="input-group">
                        <input
                          type="file"
                          ref="fileLogo"
                          accept="image/*"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div v-if="kontraktor.image != null" class="fs-8">
                        <a
                          class="text-danger cursor-pointer"
                          @click="downloadFile(kontraktor.image)"
                        >
                          File saat ini
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <p
                        class="mb-1"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        INFORMASI PJO
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-4">
                      <label for="namaPjo" class="form-label fs-8 fw-bold"
                        >Nama PJO</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="namaPjo"
                        placeholder="Masukkan Nama PJO"
                        v-model="formValues.namaPjo"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="namaPjo" class="form-label fs-8 fw-bold"
                        >Kompetensi PJO</label
                      >
                      <!--                                              <input
                          type="text"
                          class="form-control fs-9"
                          id="namaPjo"
                          placeholder="Masukkan Nama PJO"
                          v-model="formValues.namaPjo"
                      />-->
                      <select
                        class="form-select form-select-sm"
                        name="kompetensiPjo"
                        id="kompetensiPjo"
                        v-model="formValues.kompetensiPjo"
                      >
                        <option disabled value="" selected>
                          Pilih Kompetensi PJO
                        </option>
                        <option
                          :value="row.value"
                          v-for="(row, index) in kompetensiPjoOpt"
                          :key="index"
                        >
                          {{ row.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label
                        for="tanggalPengesahan"
                        class="form-label fs-8 fw-bold"
                        >Tanggal Pengesahan</label
                      >
                      <datepicker
                        v-model="formValues.tanggalPengesahan"
                        value=""
                        name="tanggalPengesahan"
                        placeholder="Masukkan Tanggal Pengesahan"
                        class="form-control fs-9"
                        input-class="fw-bold"
                        format="yyyy-MM-dd"
                      >
                      </datepicker>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <label
                        for="nomorSuratPengesahan"
                        class="form-label fs-8 fw-bold"
                        >Nomor Surat Pengesahan</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="nomorSuratPengesahan"
                        placeholder="Masukkan Nomor Surat Pengesahan"
                        v-model="formValues.nomorSuratPengesahan"
                      />
                    </div>
                    <div class="col-md-6">
                      <label
                        for="fileDokumenPengesahan"
                        class="form-label fs-8 fw-bold"
                        >File Dokumen Pengesahan</label
                      >
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileDokumenPengesahan"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFile('suratPengesahan')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizeSuratPengesahan"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max:
                        {{ max_file_size }}MB).
                      </div>
                      <div
                        v-if="validasiFile.typeSuratPengesahan"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                      </div>
                      <div
                        v-if="kontraktor.filePengesahan != null"
                        class="fs-8"
                      >
                        <a
                          class="text-danger cursor-pointer"
                          @click="downloadFile(kontraktor.filePengesahan)"
                        >
                          File saat ini
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <p
                        class="mb-1"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        INFORMASI UMUM
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="inisial" class="form-label fs-8 fw-bold"
                        >Inisial</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        :class="{ 'is-invalid': inisialDuplicateError }"
                        id="inisial"
                        placeholder="Masukkan Inisial"
                        v-model="formValues.inisial"
                        @blur="checkInisialDuplicate"
                        @input="inisialDuplicateError = ''"
                      />
                      <div
                        v-if="inisialChecking"
                        class="fs-8 text-muted fst-italic mt-1"
                      >
                        Memeriksa inisial…
                      </div>
                      <div
                        v-if="inisialDuplicateError"
                        class="fs-8 text-danger fst-italic mt-1"
                      >
                        {{ inisialDuplicateError }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label for="Klasifikasi" class="form-label fs-8 fw-bold"
                        >Klasifikasi<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <select
                        id="Klasifikasi"
                        v-model="formValues.klasifikasi"
                        @change="
                          formValues.klasifikasi == 'Inti'
                            ? (wajibIUJP = true)
                            : (wajibIUJP = false)
                        "
                        class="form-select form-select-sm"
                      >
                        <option disabled value="" selected>
                          Pilih Klasifikasi
                        </option>
                        <option
                          v-for="klas in klasifikasiOpt"
                          :key="klas"
                          :value="klas"
                        >
                          {{ klas }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="kualilifikasi" class="form-label fs-8 fw-bold"
                        >Kualifikasi Usaha<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <select
                        id="kualilifikasi"
                        v-model="formValues.kualifikasiUsaha"
                        class="form-select form-select-sm"
                      >
                        <option disabled value="" selected>
                          Pilih Kualifikasi Usaha
                        </option>
                        <option
                          v-for="kuali in kualifikasiOpt"
                          :key="kuali.value"
                          :value="kuali.value"
                        >
                          {{ kuali.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="wilayah" class="form-label fs-8 fw-bold"
                        >Wilayah</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="wilayah"
                        :disabled="true"
                        placeholder="Masukkan wilayah"
                        v-model="formValues.wilayah"
                      />
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <label for="alamat" class="form-label fs-8 fw-bold"
                        >Alamat</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="alamat"
                        placeholder="Masukkan Alamat"
                        v-model="formValues.alamat"
                      />
                    </div>
                    <div class="col-md-2">
                      <label for="provinsi" class="form-label fs-8 fw-bold"
                        >Provinsi</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="provinsi"
                        placeholder="Masukkan Provinsi"
                        v-model="formValues.provinsi"
                      />
                    </div>
                    <div class="col-md-2">
                      <label for="emailPic" class="form-label fs-8 fw-bold"
                        >Email PJO</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="emailPic"
                        placeholder="Masukkan Email"
                        v-model="formValues.emailPic"
                      />
                    </div>
                    <div class="col-md-2">
                      <label for="hpPic" class="form-label fs-8 fw-bold"
                        >No. Handphone PJO</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="hpPic"
                        placeholder="Masukkan Nomor Handphone"
                        v-model="formValues.hpPic"
                      />
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <p
                        class="mb-1"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        IZIN LEGALITAS
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="nomorNIB" class="form-label fs-8 fw-bold"
                        >Nomor NIB
                        <span class="text-danger fs-6">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="nomorNIB"
                        placeholder="Masukkan Nomor NIB"
                        v-model="formValues.nomorNIB"
                      />
                    </div>
                    <div class="col-md-6">
                      <label
                        for="fileDokumenNIB"
                        class="form-label fs-8 fw-bold"
                        >File Dokumen NIB
                        <span class="text-danger fs-6">*</span></label
                      >
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileDokumenNIB"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFile('nib')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizeNib"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max:
                        {{ max_file_size }}MB).
                      </div>
                      <div
                        v-if="validasiFile.typeNib"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                      </div>
                      <div v-if="kontraktor.fileNib != null" class="fs-8">
                        <a
                          class="text-danger cursor-pointer"
                          @click="downloadFile(kontraktor.fileNib)"
                        >
                          File saat ini
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-4">
                      <label for="nomorIUJP" class="form-label fs-8 fw-bold"
                        >Nomor IUJP
                        <span v-if="wajibIUJP" class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="nomorIUJP"
                        placeholder="Masukkan Nomor IUJP"
                        v-model="formValues.nomorIUJP"
                      />
                    </div>
                    <div class="col-md-4">
                      <label
                        for="masaBerlakuIUJP"
                        class="form-label fs-8 fw-bold"
                        >Masa Berlaku IUJP
                        <span v-if="wajibIUJP" class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <!-- <input
                    type="text"
                    class="form-control fs-9"
                    id="masaBerlakuIUJP"
                    placeholder="Masukkan Masa Berlaku IUJP" v-model="formValues.masaBerlakuIUJP"
                /> -->
                      <datepicker
                        v-model="formValues.masaBerlakuIUJP"
                        value=""
                        name="masaBerlakuIUJP"
                        placeholder="Masukkan masa berlaku IUJP"
                        class="form-control fs-9"
                        input-class="fw-bold"
                        format="yyyy-MM-dd"
                      >
                      </datepicker>
                    </div>
                    <div class="col-md-4">
                      <label
                        for="fileDokumenIUJP"
                        class="form-label fs-8 fw-bold"
                        >File Dokumen IUJP
                        <span v-if="wajibIUJP" class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileDokumenIUJP"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          aria-describedby="inputGroupFileAddon04"
                          @change="handleChangeFile('iujp')"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizeIujp"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max:
                        {{ max_file_size }}MB).
                      </div>
                      <div
                        v-if="validasiFile.typeIujp"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                      </div>
                      <div v-if="kontraktor.fileIujp != null" class="fs-8">
                        <a
                          class="text-danger cursor-pointer"
                          @click="downloadFile(kontraktor.fileIujp)"
                        >
                          File saat ini
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 mb-4">
                    <div
                      class="card border shadow-sm rounded-3 overflow-hidden"
                    >
                      <div
                        class="card-header bg-white border-0 border-bottom py-3 px-3 px-md-4"
                      >
                        <label class="form-label fs-6 fw-bold mb-0">
                          KBLI<span class="text-danger fs-6">*</span>
                        </label>
                      </div>
                      <div class="card-body p-3 p-md-4 bg-light">
                        <div
                          v-for="(row, index) in formValues.kblis"
                          :key="'kbli-' + index"
                          :class="{ 'mb-3': row.show == true }"
                        >
                          <div
                            v-if="row.show == true"
                            class="border rounded-3 p-3 p-md-4 bg-white shadow-sm"
                          >
                            <div
                              class="alert alert-danger py-2 mb-3"
                              role="alert"
                              v-if="!row.isVerified"
                            >
                              <p class="m-0 fs-6 fw-bold">
                                KBLI belum terverifikasi
                              </p>
                            </div>
                            <div
                              class="mb-3 pb-2 border-bottom border-light"
                              v-if="kbliNotesDisplay(row)"
                            >
                              <p
                                class="fs-7 mb-0"
                                :class="
                                  !row.isVerified
                                    ? 'text-danger'
                                    : 'text-secondary'
                                "
                              >
                                <span class="fw-semibold">Catatan:</span>
                                {{ kbliNotesDisplay(row) }}
                              </p>
                            </div>
                            <div class="row g-3 mb-0">
                              <div class="col-md-3">
                                <label
                                  for="kodeKbli"
                                  class="form-label fs-8 fw-bold"
                                  >Kode KBLI</label
                                >
                                <input
                                  type="text"
                                  class="form-control fs-9"
                                  :class="{
                                    'is-invalid': !row.isVerified && row.id,
                                  }"
                                  id="kodeKbli"
                                  placeholder="Masukkan Kode KBLI"
                                  v-model="row.kode"
                                />
                              </div>
                              <div class="col-md-9">
                                <label
                                  for="judulKbli"
                                  class="form-label fs-8 fw-bold"
                                  >Judul KBLI</label
                                >
                                <input
                                  type="text"
                                  class="form-control fs-9"
                                  :class="{
                                    'is-invalid': !row.isVerified && row.id,
                                  }"
                                  id="judulKbli"
                                  placeholder="Masukkan Judul KBLI"
                                  v-model="row.deskripsi"
                                />
                              </div>
                            </div>
                            <div class="row g-3 mt-1">
                              <div class="col-md-6">
                                <label
                                  for="nibKbli"
                                  class="form-label fs-8 fw-bold"
                                  >NIB</label
                                >
                                <input
                                  disabled
                                  type="text"
                                  class="form-control fs-9"
                                  id="nibKbli"
                                  placeholder="Masukkan Status NIB"
                                  v-model="row.nibKbli"
                                />
                              </div>
                              <div class="col-md-6">
                                <label
                                  for="tingkatResiko"
                                  class="form-label fs-8 fw-bold"
                                  >Tingkat Resiko OSS
                                  <span class="text-danger fs-6">*</span>
                                </label>

                                <select
                                  class="form-select form-select-sm"
                                  name="tingkatResiko"
                                  :class="{
                                    'is-invalid': !row.isVerified && row.id,
                                  }"
                                  id="tingkatResiko"
                                  v-model="row.tingkatResiko"
                                >
                                  <option
                                    :value="trOpt.value"
                                    v-for="(trOpt, indexz) in tingkatResiko"
                                    :key="indexz"
                                  >
                                    {{ trOpt.label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="row g-3 mt-1">
                              <div class="col-md-6">
                                <label
                                  for="sertifikasi"
                                  class="form-label fs-8 fw-bold"
                                  >Sertifikasi Standar</label
                                >
                                <input
                                  disabled
                                  type="text"
                                  class="form-control fs-9"
                                  id="sertifikasi"
                                  placeholder="Masukkan Sertifikasi Standar"
                                  v-model="row.sertifikasiStandar"
                                />
                              </div>
                              <div class="col-md-6">
                                <label
                                  for="FileDokumenSertifikasi"
                                  class="form-label fs-8 fw-bold"
                                  >File Dokumen Sertifikasi
                                  <span
                                    v-if="
                                      row.tingkatResiko == 2 ||
                                      row.tingkatResiko == 3
                                    "
                                    class="text-danger fs-6"
                                    >*</span
                                  ></label
                                >
                                <div class="input-group">
                                  <input
                                    :disabled="
                                      row.tingkatResiko == 1 ||
                                      row.tingkatResiko == 4
                                    "
                                    type="file"
                                    ref="FileDokumenSertifikasi"
                                    :class="{
                                      'is-invalid':
                                        !row.isVerified &&
                                        row.id &&
                                        (row.tingkatResiko == 2 ||
                                          row.tingkatResiko == 3),
                                    }"
                                    accept=".pdf"
                                    class="form-control fs-9"
                                    id="inputGroupFile04"
                                    @change="
                                      handleChangeFileKBLI(index, 'sertifikasi')
                                    "
                                    aria-describedby="inputGroupFileAddon04"
                                    aria-label="Upload"
                                    :name="'sertifikasi' + index"
                                  />
                                  <button
                                    class="btn btn-outline-secondary fs-9 border border-start-0"
                                    type="button"
                                    id="inputGroupFileAddon04"
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-cloud-arrow-up"
                                      style="color: #000000"
                                    />
                                  </button>
                                </div>
                                <div
                                  v-if="row.sizeSertifikasi"
                                  class="fs-8 text-danger fst-italic"
                                >
                                  Ukuran file melebihi batas (Max:
                                  {{ max_file_size }}MB).
                                </div>
                                <div
                                  v-if="row.typeSertifikasi"
                                  class="fs-8 text-danger fst-italic"
                                >
                                  Ekstensi file tidak sesuai, Mohon tambahkan
                                  file PDF.
                                </div>
                                <div
                                  v-if="row.fileSertifikat != null"
                                  class="fs-8"
                                >
                                  <a
                                    class="text-danger cursor-pointer"
                                    @click="downloadFile(row.fileSertifikat)"
                                  >
                                    File saat ini
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="row g-3 mt-1">
                              <div class="col-md-6">
                                <label
                                  for="izin"
                                  class="form-label fs-8 fw-bold"
                                  >Izin</label
                                >
                                <input
                                  disabled
                                  type="text"
                                  class="form-control fs-9"
                                  id="izin"
                                  v-model="row.izin"
                                />
                              </div>
                              <div class="col-md-6">
                                <label
                                  for="fileDokumenIzin"
                                  class="form-label fs-8 fw-bold"
                                  >File Dokumen Izin
                                  <span
                                    v-if="row.tingkatResiko == 4"
                                    class="text-danger fs-6"
                                    >*</span
                                  ></label
                                >
                                <div class="input-group">
                                  <input
                                    :disabled="
                                      row.tingkatResiko == 1 ||
                                      row.tingkatResiko == 2 ||
                                      row.tingkatResiko == 3
                                    "
                                    type="file"
                                    ref="FileDokumenIzin"
                                    accept=".pdf"
                                    class="form-control fs-9"
                                    :class="{
                                      'is-invalid':
                                        !row.isVerified &&
                                        row.id &&
                                        row.tingkatResiko == 4,
                                    }"
                                    @change="
                                      handleChangeFileKBLI(index, 'izin')
                                    "
                                    id="inputGroupFile04"
                                    aria-describedby="inputGroupFileAddon04"
                                    aria-label="Upload"
                                  />
                                  <button
                                    class="btn btn-outline-secondary fs-9 border border-start-0"
                                    type="button"
                                    id="inputGroupFileAddon04"
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-cloud-arrow-up"
                                      style="color: #000000"
                                    />
                                  </button>
                                </div>
                                <div
                                  v-if="row.sizeIzin"
                                  class="fs-8 text-danger fst-italic"
                                >
                                  Ukuran file melebihi batas (Max:
                                  {{ max_file_size }}MB).
                                </div>
                                <div
                                  v-if="row.typeIzin"
                                  class="fs-8 text-danger fst-italic"
                                >
                                  Ekstensi file tidak sesuai, Mohon tambahkan
                                  file PDF.
                                </div>
                                <div v-if="row.fileIzin != null" class="fs-8">
                                  <a
                                    class="text-danger cursor-pointer"
                                    @click="downloadFile(row.fileIzin)"
                                  >
                                    File saat ini
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              class="mt-3 pt-2 border-top border-light"
                              v-if="row.updatedAt"
                            >
                              <p
                                class="text-start fs-8 fst-italic text-secondary mb-0"
                              >
                                Update terakhir :
                                <b>{{
                                  moment(row.updatedAt).format(
                                    "YYYY-MM-DD HH:mm:ss",
                                  )
                                }}</b>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="mt-2 pt-2 border-top border-secondary border-opacity-25"
                        >
                          <button
                            type="button"
                            class="btn btn-link text-danger text-decoration-none p-0 fw-bold small d-inline-flex align-items-center gap-1"
                            @click="tambahKBLI()"
                          >
                            <font-awesome-icon icon="fa-solid fa-circle-plus" />
                            Tambah KBLI
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-4">
                    <div
                      class="card border shadow-sm rounded-3 overflow-hidden"
                    >
                      <div
                        class="card-header bg-white border-0 border-bottom py-3 px-3 px-md-4"
                      >
                        <label class="form-label fs-6 fw-bold mb-0">
                          Bidang IUJP<span
                            v-if="wajibIUJP"
                            class="text-danger fs-6"
                            >*</span
                          >
                        </label>
                      </div>
                      <div class="card-body p-3 p-md-4 bg-light">
                        <div
                          v-for="(row, index) in formValues.bidangs"
                          :key="'bidang-' + index"
                          class="mb-3"
                        >
                          <div
                            class="border rounded-3 p-3 p-md-4 bg-white shadow-sm"
                          >
                            <div
                              class="alert alert-danger py-2 mb-3"
                              role="alert"
                              v-if="row.is_verified === 'false'"
                            >
                              <p class="m-0 fs-6 fw-bold">
                                Bidang IUJP belum terverifikasi
                              </p>
                            </div>
                            <div
                              class="mb-3 pb-2 border-bottom border-light"
                              v-if="bidangNotesDisplay(row)"
                            >
                              <p
                                class="fs-7 mb-0"
                                :class="
                                  !row.is_verified
                                    ? 'text-danger'
                                    : 'text-secondary'
                                "
                              >
                                <span class="fw-semibold">Catatan:</span>
                                {{ bidangNotesDisplay(row) }}
                              </p>
                            </div>
                            <div class="row g-3 align-items-end">
                              <div class="col-md-3">
                                <label
                                  for="bidang"
                                  class="form-label fs-8 fw-bold"
                                  >Bidang</label
                                >
                                <select
                                  v-model="row.NMBIDANG"
                                  id="selectBox"
                                  @change="handleChangeBidang(index)"
                                  class="form-select form-select-sm"
                                >
                                  <option
                                    v-for="rbid in ref_bidang"
                                    :key="rbid.id"
                                    :value="rbid.bidang"
                                  >
                                    {{ rbid.bidang }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-md-8">
                                <label
                                  for="subBidang"
                                  class="form-label fs-8 fw-bold"
                                  >Sub Bidang</label
                                >

                                <select
                                  v-model="row.SUBBIDANG"
                                  id="selectBox"
                                  @change="handleChangeSubbidang(index)"
                                  class="form-select form-select-sm"
                                >
                                  <option
                                    v-for="rsbid in ref_subbidang[index]"
                                    :key="rsbid.id"
                                    :value="rsbid.bidang"
                                  >
                                    {{ rsbid.bidang }}
                                  </option>
                                </select>
                              </div>
                              <div
                                class="col-md-1 d-flex align-items-center justify-content-center pb-1 pb-md-2"
                              >
                                <button
                                  type="button"
                                  class="btn btn-link text-danger p-0 border-0"
                                  title="Hapus baris"
                                  @click="hapusBidang(index)"
                                >
                                  <font-awesome-icon
                                    icon="fa-solid fa-trash"
                                    class="fs-5"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="mt-2 pt-2 border-top border-secondary border-opacity-25"
                        >
                          <button
                            type="button"
                            class="btn btn-link text-danger text-decoration-none p-0 fw-bold small d-inline-flex align-items-center gap-1"
                            @click="tambahBidang()"
                          >
                            <font-awesome-icon icon="fa-solid fa-circle-plus" />
                            Tambah Bidang & Sub Bidang
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="changesInformation.statusChanges !== 'created'"
                  >
                    <div class="col-md-12 d-flex justify-content-end">
                      <button
                        type="button"
                        @click="clickSimpan()"
                        class="btn btn_cari w-25"
                      >
                        Simpan
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}

.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SET_KONTRAKTOR,
  CMS_CHECK_INISIAL,
  CMS_DOWNLOAD,
  CMS_GET_BIDANG,
  CMS_GET_CHANGES_INFORMATION,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import util from "@/assets/js/util";
import UploadFileService from "@/utilities/upload-file";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_simpan = API_BASE_URL + CMS_SET_KONTRAKTOR;
const url_check_inisial = API_BASE_URL + CMS_CHECK_INISIAL;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_bidang = API_BASE_URL + CMS_GET_BIDANG;
const url_get_changes_information_kontraktor =
  API_BASE_URL + CMS_GET_CHANGES_INFORMATION;
const max_file_size = 5; // MB

export default {
  mixins: [GlobalDataMixin],
  name: "ProfilePage",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      isLoading: true,
      tingkatResiko: [
        { value: null, label: null },
        { value: 1, label: "Rendah" },
        { value: 2, label: "Menengah Rendah" },
        { value: 3, label: "Menengah Tinggi" },
        { value: 4, label: "Tinggi" },
      ],
      kompetensiPjoOpt: [
        { value: "POP", label: "POP (Pengawas Operasional Pertama)" },
        { value: "POM", label: "POM (Pengawas Operasional Madya)" },
        { value: "POU", label: "POU (Pengawas Operasional Utama)" },
      ],
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      ref_bidangall: [],
      ref_bidang: [],
      ref_subbidang: [[]],
      klasifikasiOpt: ["Inti", "Non Inti"],
      temp_kblis: [
        { kode: "", deskripsi: "", tingkatResiko: "", tingkatResikoStr: "" },
      ],
      final_kblis: [],
      deleted_kblis: [],
      added_kblis: [],
      wajibIUJP: false,
      formValues: {
        namaKontraktor: "",
        logo: "",
        inisial: "",
        klasifikasi: "",
        kualifikasiUsaha: "",
        wilayah: "",
        alamat: "",
        provinsi: "",
        emailPic: "",
        hpPic: "",
        nomorNIB: "",
        nomorIUJP: "",
        namaPjo: "",
        nomorSuratPengesahan: "",
        tanggalPengesahan: "",
        masaBerlakuIUJP: "",
        kompetensiPjo: "",
        kblis: [],
        bid: [],
        subbid: [],
        bidangs: [
          { NMBIDANG: "", SUBBIDANG: "", is_verified: false, notes: null },
        ],
        fileDokumenPengesahan: "",
        fileDokumenIUJP: "",
        fileDokumenNIB: "",
      },
      validasiFile: {
        typeIujp: false,
        sizeIujp: false,
        typeNib: false,
        sizeNib: false,
        typeSuratPengesahan: false,
        sizeSuratPengesahan: false,
      },
      kualifikasiOpt: [
        { value: 1, label: "Kecil" },
        { value: 2, label: "Sedang" },
        { value: 3, label: "Besar" },
      ],
      count_kbli_previous: null,
      count_bidangs_previous: null,
      /** Fingerprint isi baris bidang saat form selesai diisi (GET + optional snapshot rejected). */
      bidangsBaselineFingerprints: [],
      inisialAsLoaded: "",
      inisialDuplicateError: "",
      inisialChecking: false,
      inisialCheckToken: 0,
      uploadFileService: null,
      changesInformation: {},
    };
  },
  mounted() {
    this.getBidang();
  },
  created() {
    this.uploadFileService = new UploadFileService(
      this.userData.token,
      Array.isArray(this.userData.role) ? "isafe" : "kontraktor",
    );
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    /** true = inisial bentrok / tidak dipakai (when API says available === false). */
    isInisialDuplicateFromResponse(payload) {
      if (!payload || typeof payload !== "object") {
        return false;
      }
      if ("available" in payload) {
        return payload.available === false;
      }
      const inner = payload.data;
      if (inner && typeof inner === "object" && "available" in inner) {
        return inner.available === false;
      }
      return false;
    },
    async fetchInisialDuplicateFromApi() {
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return { duplicate: false };
      }

      const loaded = (this.inisialAsLoaded || "").trim().toLowerCase();
      if (trimmed.toLowerCase() === loaded) {
        return { duplicate: false };
      }
      const { data } = await axios.get(url_check_inisial, {
        params: {
          id_kontraktor: this.userData.kontraktorID,
          inisial: trimmed,
        },
        headers: {
          role: this.userData.role,
          Authorization: "Bearer " + this.userData.token,
          accept: "*/*",
        },
      });
      return { duplicate: this.isInisialDuplicateFromResponse(data) };
    },
    async checkInisialDuplicate() {
      this.inisialDuplicateError = "";
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return;
      }
      const token = ++this.inisialCheckToken;
      this.inisialChecking = true;
      try {
        const { duplicate } = await this.fetchInisialDuplicateFromApi();
        if (token !== this.inisialCheckToken) {
          return;
        }
        if (duplicate) {
          this.inisialDuplicateError =
            "Inisial sudah digunakan. Silakan gunakan inisial lain.";
        }
      } catch (e) {
        if (token !== this.inisialCheckToken) {
          return;
        }
        const msg =
          e.response?.data?.message ||
          e.response?.data?.status?.message ||
          "Gagal memeriksa inisial.";
        this.inisialDuplicateError = msg;
      } finally {
        if (token === this.inisialCheckToken) {
          this.inisialChecking = false;
        }
      }
    },
    async validateInisialBeforeSubmit() {
      this.inisialDuplicateError = "";
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return true;
      }
      this.inisialChecking = true;
      try {
        const { duplicate } = await this.fetchInisialDuplicateFromApi();
        if (duplicate) {
          this.inisialDuplicateError =
            "Inisial sudah digunakan. Silakan gunakan inisial lain.";
          return false;
        }
        return true;
      } catch (e) {
        const msg =
          e.response?.data?.message ||
          e.response?.data?.status?.message ||
          "Gagal memeriksa inisial.";
        this.inisialDuplicateError = msg;
        return false;
      } finally {
        this.inisialChecking = false;
      }
    },
    fetchData(id) {
      console.log("param id nya = ", id);
      axios
        .get(url + id, { headers: { accept: "application/json" } })
        .then((response) => {
          console.log("response =>", response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          this.formValues.namaKontraktor = this.kontraktor.namaKontraktor;
          this.formValues.inisial = this.kontraktor.inisial;
          this.inisialAsLoaded = (this.kontraktor.inisial || "").trim();
          this.inisialDuplicateError = "";
          this.formValues.klasifikasi = this.kontraktor.jenis;
          this.formValues.kualifikasiUsaha = this.kontraktor.kualifikasiUsaha;
          // this.formValues.klasifikasi = 'Non Inti'
          this.formValues.wilayah = this.kontraktor.wilayah;
          this.formValues.nomorNIB = this.kontraktor.nib;
          this.formValues.nomorIUJP = this.kontraktor.iujp;
          this.formValues.masaBerlakuIUJP = this.kontraktor.masaBerlaku;
          this.formValues.nomorSuratPengesahan =
            this.kontraktor.noPengesahanPjo;
          this.formValues.tanggalPengesahan =
            this.kontraktor.tglSuratPengesahan;
          this.formValues.namaPjo = this.kontraktor.namaPjo;
          this.formValues.kompetensiPjo = this.kontraktor.kompetensiPjo;

          if (this.formValues.klasifikasi.toLocaleLowerCase() == "inti") {
            this.wajibIUJP = true;
          }
          this.formValues.alamat = this.kontraktor.alamat;
          this.formValues.provinsi = this.kontraktor.provinsi;
          this.formValues.emailPic = this.kontraktor.picEmail;
          this.formValues.hpPic = this.kontraktor.picPhone;
          // end : set value form edit

          // loop bidang-subbidang
          var arr_bid = [];
          var arr_bidx = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              const subNorm = this.normalizeBidangText(String(subi[xx]));
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subNorm,
              });
              arr_bidx.push({
                bidang: key,
                subBidang: subNorm,
              });
              asbd.push(b + "." + sb + ". " + subNorm);
              sb++;
            }
          }
          this.bidang = arr_bid;
          if (arr_bidx.length) {
            let arr_bids = [];
            for (var z in arr_bidx) {
              var bd = arr_bidx[z];
              const dec = this.decodeBidangRowFields({
                SUBBIDANG: bd.subBidang,
              });
              arr_bids.push({
                NMBIDANG: this.normalizeBidangText(bd.bidang),
                SUBBIDANG: dec.SUBBIDANG,
                is_verified: dec.is_verified,
                notes: dec.notes,
              });

              // set ref sub bidang saat fetch data
              let nmb = this.ref_bidangall.filter(
                (option) => option.bidang === bd.bidang,
              );
              if (nmb.length > 0) {
                console.log("data =", nmb);
                console.log("data2 = ", nmb[0].id);
                this.ref_subbidang.push(this.getSubBidang(nmb[0].id, z));
              }
            }
            this.formValues.bidangs = arr_bids;
          }

          // end loop bidang-subbidang

          let kbli = response.data.dataKbli;
          if (kbli.length > 0) {
            let arr_kbli = [];
            let arr_kbli_o = [];
            for (var k in kbli) {
              var kb = kbli[k];
              let izin = kbli[k].noKbli == "9900" ? "Terbit" : "-";
              let nibKbli =
                this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit";
              let sertifikatStandarStr =
                kbli[k].fileSertifikat != null
                  ? "Terverifikasi"
                  : "Belum Terverifikasi";
              arr_kbli.push({
                id: kb.id,
                kode: kb.noKbli,
                deskripsi: kb.deskripsi,
                izin: izin,
                sertifikasiStandar: sertifikatStandarStr,
                nibKbli: nibKbli,
                tingkatResiko: kb.tingkatResiko,
                // tingkatResikoStr: kb.tingkatResikoStr,
                show: true,
                deleted: false,
                updatedAt: kb.updatedAt,
                sizeSertifikasi: false,
                typeSertifikasi: false,
                sizeIzin: false,
                typeIzin: false,
                fileSertifikat: kb.fileSertifikat,
                fileIzin: kb.fileIzin,
                isVerified: kb.isVerified,
                notes: kb.notes,
              });
              arr_kbli_o.push({
                id: kb.id,
                kode: kb.noKbli,
                deskripsi: kb.deskripsi,
                izin: izin,
                sertifikasiStandar: sertifikatStandarStr,
                nibKbli: nibKbli,
                tingkatResiko: kb.tingkatResiko,
                // tingkatResikoStr: kb.tingkatResikoStr,
                updatedAt: kb.updatedAt,
                isVerified: kb.isVerified,
                notes: kb.notes,
                fileSertifikat: kb.fileSertifikat ?? null,
                fileIzin: kb.fileIzin ?? null,
              });
            }
            this.formValues.kblis = arr_kbli;
            this.temp_kblis = arr_kbli_o;
          } else {
            this.formValues.kblis = [];
            this.temp_kblis = [];
          }
          this.count_kbli_previous = this.formValues.kblis.length;
          this.count_bidangs_previous = this.formValues.bidangs.length;
          this.bd = abd;
          this.sbd = asbd;
          this.isLoading = false;
          this.getInformationChangesKontraktor(id).finally(() => {
            this.captureBidangsBaseline();
          });
        })
        .catch((error) => {
          this.isLoading = false;
          util.showError(
            "Gagal mendapatkan detail kontraktor : " + error.message,
          );
        });
    },
    /**
     * Respons POST `cms/changes/information` (kontraktor), bentuk resmi:
     * {
     *   kontraktorId, statusChanges, reason, notificationId?,
     *   dataChanges: object | string JSON   // snapshot isian; somethingChange, kblis, surat*, file*, …
     * }
     * Field meta (alasan penolakan, status) di root; isian form di `dataChanges`.
     */
    getInformationChangesKontraktor(kontraktorId) {
      if (kontraktorId == null) {
        return Promise.resolve();
      }
      const bodyJson = { kontraktorId };
      return axios
        .post(url_get_changes_information_kontraktor, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.changesInformation = response.data || {};
          const ci = this.changesInformation;
          if (String(ci.statusChanges ?? "").toLowerCase() !== "rejected") {
            return;
          }
          const dc = this.getRejectedPayloadFromChangesInformation(ci);
          if (dc) {
            this.applyRejectedChangesSnapshot(dc);
          }
        })
        .catch((error) => {
          console.log("error getInformationChangesKontraktor : ", error);
        });
    },
    getRejectedPayloadFromChangesInformation(ci) {
      if (!ci || typeof ci !== "object") {
        return null;
      }
      const raw = ci.dataChanges;

      /* Jalur normal: `dataChanges` objek biasa (bukan array / string). */
      if (raw != null && typeof raw === "object" && !Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw);
          if (
            typeof parsed === "object" &&
            parsed !== null &&
            !Array.isArray(parsed)
          ) {
            return parsed;
          }
          return null;
        } catch {
          return null;
        }
      }

      /* Kontrak service: snapshot selalu di `dataChanges`. Tanpa itu tidak merge ke form. */
      return null;
    },
    parseBidangUsahaGemsForRejectedSnapshot(raw) {
      if (raw == null || raw === "") {
        return [];
      }
      let bidang = raw;
      if (typeof raw === "string") {
        try {
          bidang = JSON.parse(raw);
        } catch {
          return [];
        }
      }
      if (!Array.isArray(bidang) || bidang.length === 0) {
        return [];
      }
      const out = [];
      for (const item of bidang) {
        if (!item || String(item.NMBIDANG ?? "").trim() === "") {
          continue;
        }
        const dec = this.decodeBidangRowFields(item);
        out.push({
          NMBIDANG: this.normalizeBidangText(item.NMBIDANG),
          SUBBIDANG: dec.SUBBIDANG,
          is_verified: dec.is_verified,
          notes: dec.notes,
        });
      }
      return out;
    },
    normalizeBidangIsVerifiedValue(v) {
      if (v === true || v === "true") {
        return true;
      }
      return false;
    },
    normalizeBidangNotesForFingerprint(n) {
      if (n == null || n === "") {
        return "";
      }
      if (typeof n === "object") {
        try {
          return JSON.stringify(n);
        } catch {
          return String(n);
        }
      }
      return this.normalizeBidangText(String(n).trim());
    },
    /**
     * Data bidang dari API kadang menyisipkan `\n` di nama sub-bidang; rapikan
     * agar split `...-is_verified-notes` dan fingerprint konsisten.
     */
    normalizeBidangText(value) {
      if (value == null) {
        return "";
      }
      return String(value)
        .replace(/\r\n/g, "\n")
        .replace(/\n/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },
    /**
     * Helper untuk membersihkan nama sub-bidang dari penumpukan suffix -(true|false)-(null|...).
     */
    cleanSubBidangText(raw) {
      if (!raw) return "";
      let text = this.normalizeBidangText(raw);
      while (/-(true|false)-(null|undefined|[a-zA-Z0-9\s]*)$/i.test(text)) {
        text = text
          .replace(/-(true|false)-(null|undefined|[a-zA-Z0-9\s]*)$/i, "")
          .trim();
      }
      return text;
    },
    /**
     * String sub-bidang dari API / snapshot kadang menyatu:
     * `Nama Sub Bidang-true-oke` (verified + catatan di sufiks). Pecah dari kanan
     * agar nama yang mengandung `-` tetap benar dan bersih dari penumpukan suffix.
     */
    decodeBidangRowFields(item) {
      const rawSub = item?.SUBBIDANG ?? "";
      const s = String(rawSub ?? "");
      if (!s.trim()) {
        return {
          SUBBIDANG: "",
          is_verified: false,
          notes: null,
          fromEncodedSuffix: false,
        };
      }
      const m = s.match(/^([\s\S]*)-(true|false)-([\s\S]*)$/i);
      if (m) {
        const tail = String(m[3] ?? "").trim();
        const notes =
          tail === "" ||
          tail.toLowerCase() === "null" ||
          tail.toLowerCase() === "undefined"
            ? null
            : tail;
        return {
          SUBBIDANG: this.cleanSubBidangText(m[1]),
          is_verified: m[2].toLowerCase() === "true",
          notes,
          fromEncodedSuffix: true,
        };
      }
      let is_verified = false;
      const iv = item?.isVerified ?? item?.is_verified;
      if (typeof iv === "boolean") {
        is_verified = iv;
      } else if (iv != null && iv !== "") {
        try {
          is_verified = JSON.parse(iv);
        } catch {
          is_verified = !!iv;
        }
      }
      let notes = null;
      const n = item?.notes;
      if (n != null && n !== "") {
        try {
          notes = JSON.parse(n);
        } catch {
          notes = n;
        }
      }
      return {
        SUBBIDANG: this.cleanSubBidangText(s),
        is_verified,
        notes,
        fromEncodedSuffix: false,
      };
    },
    bidangContentFingerprint(row) {
      return JSON.stringify({
        NMBIDANG: this.normalizeBidangText(row?.NMBIDANG),
        SUBBIDANG: this.normalizeBidangText(row?.SUBBIDANG),
        notes: this.normalizeBidangNotesForFingerprint(row?.notes),
        is_verified: this.normalizeBidangIsVerifiedValue(row?.is_verified),
      });
    },
    /** Kode KBLI dari payload snapshot penolakan (`noKbli` / `kode`). */
    extractKodeFromRejectedKbSnap(kb) {
      if (!kb) {
        return "";
      }
      if (kb.noKbli != null && String(kb.noKbli).trim() !== "") {
        return String(kb.noKbli).trim();
      }
      if (kb.kode != null && String(kb.kode).trim() !== "") {
        return String(kb.kode).trim();
      }
      return "";
    },
    /**
     * Satu baris form KBLI: baseline dari GET detail (`temp_kblis`) + opsional baris
     * yang sama dari `dataChanges.kblis` (hanya isian yang berubah).
     */
    formKbliRowFromBaselineAndSnapshot(base, snap, nibStr) {
      const fileCert = snap
        ? snap.suratSertifikasi ??
          snap.fileSertifikat ??
          base.fileSertifikat ??
          null
        : base.fileSertifikat ?? null;
      const filePerm = snap
        ? snap.suratIzin ?? snap.fileIzin ?? base.fileIzin ?? null
        : base.fileIzin ?? null;

      let noKb = snap ? this.extractKodeFromRejectedKbSnap(snap) : "";
      if (noKb === "" && snap?.id != null && base?.kode != null) {
        const bk = String(base.kode).trim();
        if (bk !== "") {
          noKb = bk;
        }
      }
      if (noKb === "" && base?.kode != null) {
        noKb = String(base.kode).trim();
      }

      const deskripsi =
        snap && snap.deskripsi != null ? snap.deskripsi : base.deskripsi ?? "";
      const tingkatResiko =
        snap && snap.tingkatResiko != null
          ? snap.tingkatResiko
          : base.tingkatResiko;
      const id = snap && snap.id != null ? snap.id : base.id;
      const notes = snap && "notes" in snap ? snap.notes : base.notes;
      const isVerified =
        snap && "isVerified" in snap ? snap.isVerified : base.isVerified;
      const updatedAt =
        snap && snap.updatedAt != null ? snap.updatedAt : base.updatedAt;

      const kode = noKb;
      const izin = kode === "9900" ? "Terbit" : "-";
      const nibKbli = nibStr !== "" ? "Terbit" : "Tidak Terbit";
      const sertifikatStandarStr =
        fileCert != null ? "Terverifikasi" : "Belum Terverifikasi";

      return {
        id,
        kode,
        deskripsi: deskripsi ?? "",
        izin,
        sertifikasiStandar: sertifikatStandarStr,
        nibKbli,
        tingkatResiko,
        show: true,
        deleted: false,
        updatedAt,
        sizeSertifikasi: false,
        typeSertifikasi: false,
        sizeIzin: false,
        typeIzin: false,
        fileSertifikat: fileCert,
        fileIzin: filePerm,
        isVerified,
        notes,
      };
    },
    captureBidangsBaseline() {
      const rows = this.formValues.bidangs || [];
      this.bidangsBaselineFingerprints = rows.map((r) =>
        this.bidangContentFingerprint(r),
      );
    },
    buildBidangsPayloadForApi() {
      let rows = this.formValues.bidangs || [];
      const hasFilledRow = rows.some(
        (row) =>
          row.NMBIDANG?.trim() !== "" && row.SUBBIDANG?.trim() !== "",
      );
      if (!hasFilledRow) {
        return [];
      }
      if (rows.length > 1) {
        rows = rows.filter(
          (row) =>
            row.NMBIDANG?.trim() !== "" || row.SUBBIDANG?.trim() !== "",
        );
      }
      if (rows.length === 0) {
        return [];
      }
      const pool = Array.isArray(this.bidangsBaselineFingerprints)
        ? [...this.bidangsBaselineFingerprints]
        : [];
      return rows.map((row) => {
        const fp = this.bidangContentFingerprint(row);
        const j = pool.indexOf(fp);
        const unchanged = j !== -1;
        if (unchanged) {
          pool.splice(j, 1);
        }
        const isVerifiedOut = unchanged
          ? this.normalizeBidangIsVerifiedValue(row.is_verified)
          : false;
        return { ...row, is_verified: isVerifiedOut };
      });
    },
    applyRejectedChangesSnapshot(dc) {
      if (!dc || typeof dc !== "object") {
        return;
      }
      if (dc.namaKontraktor != null) {
        this.formValues.namaKontraktor = dc.namaKontraktor;
      }
      if (dc.inisial != null) {
        this.formValues.inisial = dc.inisial;
      }
      if (dc.iujp === true || dc.iujp === false) {
        this.formValues.klasifikasi = dc.iujp ? "Inti" : "Non Inti";
        this.wajibIUJP = dc.iujp === true;
      } else if (typeof dc.jenis === "string" && dc.jenis !== "") {
        this.formValues.klasifikasi = dc.jenis;
        this.wajibIUJP = dc.jenis.toLowerCase() === "inti";
      }
      if (dc.kualifikasiUsaha != null && dc.kualifikasiUsaha !== "") {
        this.formValues.kualifikasiUsaha = dc.kualifikasiUsaha;
      }
      if (dc.wilayah != null) {
        this.formValues.wilayah = dc.wilayah;
      }
      if (dc.noNib != null) {
        this.formValues.nomorNIB = dc.noNib;
      }
      if (dc.noIujp != null) {
        this.formValues.nomorIUJP = dc.noIujp;
      }
      if (dc.tglExpIujp != null && dc.tglExpIujp !== "") {
        this.formValues.masaBerlakuIUJP = dc.tglExpIujp;
      }
      if (dc.noPengesahanPjo != null) {
        this.formValues.nomorSuratPengesahan = dc.noPengesahanPjo;
      }
      if (dc.tglSuratPengesahan != null) {
        this.formValues.tanggalPengesahan = dc.tglSuratPengesahan;
      }
      if (dc.namaPjo != null) {
        this.formValues.namaPjo = dc.namaPjo;
      }
      if (dc.kompetensiPjo != null) {
        this.formValues.kompetensiPjo = dc.kompetensiPjo;
      }
      if (dc.alamat != null) {
        this.formValues.alamat = dc.alamat;
      }
      if (dc.provinsi != null) {
        this.formValues.provinsi = dc.provinsi;
      }
      if (dc.picEmail != null) {
        this.formValues.emailPic = dc.picEmail;
      }
      if (dc.picPhone != null) {
        this.formValues.hpPic = dc.picPhone;
      }
      const filePatch = {};
      if (dc.image != null && dc.image !== "") {
        filePatch.image = dc.image;
      }
      if (dc.filePengesahan != null && dc.filePengesahan !== "") {
        filePatch.filePengesahan = dc.filePengesahan;
      }
      if (dc.fileNib != null && dc.fileNib !== "") {
        filePatch.fileNib = dc.fileNib;
      }
      if (dc.fileIujp != null && dc.fileIujp !== "") {
        filePatch.fileIujp = dc.fileIujp;
      }
      if (Object.keys(filePatch).length) {
        Object.assign(this.kontraktor, filePatch);
      }

      const bidRows = this.parseBidangUsahaGemsForRejectedSnapshot(
        dc.bidangUsahaGems,
      );
      if (bidRows.length > 0) {
        this.formValues.bidangs = bidRows;
        this.ref_subbidang = [];
        for (let z = 0; z < bidRows.length; z++) {
          this.ref_subbidang.push([]);
          const row = bidRows[z];
          const nmb = this.ref_bidangall.filter(
            (option) => option.bidang === row.NMBIDANG,
          );
          if (nmb.length > 0) {
            this.getSubBidang(nmb[0].id, z);
          }
        }
      }

      if (Array.isArray(dc.kblis) && dc.kblis.length > 0) {
        const snapshotList = dc.kblis.filter(Boolean);
        const baselineRows =
          Array.isArray(this.temp_kblis) && this.temp_kblis.length > 0
            ? [...this.temp_kblis]
            : [];
        const nibStr = String(this.formValues.nomorNIB ?? "");
        const arr_kbli = [];
        const usedSnap = new Set();

        const snapMatchesBase = (snap, base) => {
          if (
            base?.id != null &&
            snap?.id != null &&
            String(base.id) === String(snap.id)
          ) {
            return true;
          }
          const sk = this.extractKodeFromRejectedKbSnap(snap);
          const bk = base?.kode != null ? String(base.kode).trim() : "";
          return sk !== "" && bk !== "" && sk === bk;
        };

        for (let b = 0; b < baselineRows.length; b++) {
          const base = baselineRows[b];
          let snap = null;
          let snapIdx = -1;
          for (let s = 0; s < snapshotList.length; s++) {
            if (usedSnap.has(s)) {
              continue;
            }
            if (snapMatchesBase(snapshotList[s], base)) {
              snap = snapshotList[s];
              snapIdx = s;
              break;
            }
          }
          if (snapIdx !== -1) {
            usedSnap.add(snapIdx);
          }
          arr_kbli.push(
            this.formKbliRowFromBaselineAndSnapshot(base, snap, nibStr),
          );
        }

        for (let s = 0; s < snapshotList.length; s++) {
          if (usedSnap.has(s)) {
            continue;
          }
          const kb = snapshotList[s];
          const synthetic = {
            id: kb.id ?? null,
            kode: this.extractKodeFromRejectedKbSnap(kb) || "",
            deskripsi: kb.deskripsi ?? "",
            nibKbli: nibStr !== "" ? "Terbit" : "Tidak Terbit",
            tingkatResiko: kb.tingkatResiko,
            updatedAt: kb.updatedAt,
            isVerified: kb.isVerified,
            notes: kb.notes,
            fileSertifikat: null,
            fileIzin: null,
          };
          if (
            synthetic.kode === "" &&
            kb.id != null &&
            baselineRows.length > 0
          ) {
            const baseline = baselineRows.find(
              (t) => String(t.id ?? "") === String(kb.id ?? ""),
            );
            if (
              baseline != null &&
              baseline.kode != null &&
              String(baseline.kode).trim() !== ""
            ) {
              synthetic.kode = String(baseline.kode).trim();
            }
          }
          arr_kbli.push(
            this.formKbliRowFromBaselineAndSnapshot(synthetic, kb, nibStr),
          );
        }

        this.formValues.kblis = arr_kbli;
        /**
         * Jangan timpa `temp_kblis`: itu baseline dari GET detail untuk
         * compareKBLIS(). Form menampilkan semua KBLI dari detail + merge snapshot
         * penolakan per baris (dataChanges biasanya hanya subset yang berubah).
         */
      }

      this.inisialDuplicateError = "";
    },
    tambahKBLI() {
      this.formValues.kblis.push({
        kode: "",
        deskripsi: "",
        tingkatResiko: "",
        nibKbli: "Tidak Terbit",
        show: true,
      });
    },
    hapusKBLI(index) {
      if (this.formValues.kblis[index].id != null) {
        this.deleted_kblis.push(this.formValues.kblis[index]);
      } else if (this.formValues.kblis[index].id == null) {
        this.added_kblis = this.added_kblis.filter(
          (item) => item.kode !== this.formValues.kblis[index].kode,
        );
      }

      if (this.$refs.FileDokumenSertifikasi[index] != null) {
        this.$refs.FileDokumenSertifikasi[index].value = "";
      }
      if (this.$refs.FileDokumenIzin[index] != null) {
        this.$refs.FileDokumenIzin[index].value = "";
      }

      // console.log(this.$refs.FileDokumenIzin);

      // this.formValues.kblis.splice(index,1)
      this.formValues.kblis[index].show = false;
      this.formValues.kblis[index].deleted = true;
    },
    /** Teks catatan (KBLI / IUJP): abaikan null, kosong, string "null". */
    notesDisplayValue(n) {
      if (n == null) {
        return "";
      }
      if (typeof n === "object") {
        try {
          return JSON.stringify(n);
        } catch {
          return String(n);
        }
      }
      const s = String(n).trim();
      if (s === "" || s.toLowerCase() === "null") {
        return "";
      }
      return s;
    },
    bidangNotesDisplay(row) {
      return this.notesDisplayValue(row?.notes);
    },
    kbliNotesDisplay(row) {
      return this.notesDisplayValue(row?.notes);
    },
    tambahBidang() {
      this.formValues.bidangs.push({
        NMBIDANG: "",
        SUBBIDANG: "",
        is_verified: false,
        notes: null,
      });
    },
    hapusBidang(index) {
      this.formValues.bidangs.splice(index, 1);
      this.ref_subbidang.splice(index, 1);
    },
    getBidang() {
      axios
        .post(
          url_get_bidang,
          {},
          {
            headers: {
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          },
        )
        .then((response) => {
          if (response.status == 200) {
            const data_bidang = response.data.data || [];
            this.ref_bidangall = data_bidang.map((row) => ({
              ...row,
              bidang: this.normalizeBidangText(row.bidang),
            }));
            this.ref_bidang = [];
            for (let i = 0; i < this.ref_bidangall.length; i++) {
              if (
                this.ref_bidangall[i].id == this.ref_bidangall[i].bidangParent
              ) {
                this.ref_bidang.push({
                  id: this.ref_bidangall[i].id,
                  bidang: this.ref_bidangall[i].bidang,
                });
              }
            }
            this.fetchData(
              this.userData.kontraktorID != null
                ? this.userData.kontraktorID
                : this.$route.params.id,
            );
          }
        })
        .catch((error) => {
          util.showError(
            "Gagal mendapatkan data bidang : " + error.response.data.message,
          );
        });
    },
    getSubBidang(id_parent, index) {
      this.ref_subbidang[index] = [];
      let rsb = [];
      for (let i = 0; i < this.ref_bidangall.length; i++) {
        if (
          this.ref_bidangall[i].bidangParent == id_parent &&
          this.ref_bidangall[i].id != id_parent
        ) {
          rsb.push({
            id: this.ref_bidangall[i].id,
            bidang: this.ref_bidangall[i].bidang,
          });
        }
      }
      this.ref_subbidang[index] = rsb;
    },
    handleChangeBidang(index) {
      const matchingOption = this.ref_bidangall.find(
        (option) => option.bidang === this.formValues.bidangs[index].NMBIDANG,
      );
      let id_parent = matchingOption.id;

      this.getSubBidang(id_parent, index);
    },
    handleChangeSubbidang(index) {
      console.log(
        `Selected sub bidang ${index + 1}:`,
        this.formValues.bidangs[index].SUBBIDANG,
      );
    },

    /** Nama file dari respons `cms/upload/file` (uploadFileService). */
    filenameFromUploadResponse(res) {
      if (!res || typeof res !== "object") {
        return null;
      }
      return res.filename ?? null;
    },

    /**
     * Upload logo / pengesahan / IUJP / NIB paralel (tidak menunggu simpan profil).
     * Mengembalikan map field body sama seperti sebelumnya: image, filePengesahan, fileIujp, fileNib.
     */
    async uploadKontraktorDocumentsViaService(files, purposes) {
      const keyByPurpose = {
        kontraktor: "image",
        pengesahan: "filePengesahan",
        iujp: "fileIujp",
        nib: "fileNib",
      };
      if (!files?.length || !this.uploadFileService) {
        return {};
      }
      const tasks = files.map((file, i) =>
        this.uploadFileService.uploadFile(file).then((res) => ({
          key: keyByPurpose[purposes[i]],
          res,
          label: purposes[i],
        })),
      );
      const settled = await Promise.all(tasks);
      const fileNames = {};
      for (const { key, res, label } of settled) {
        const name = this.filenameFromUploadResponse(res);
        if (!key || !name) {
          throw new Error(
            `Upload ${
              label || "file"
            } gagal: nama file tidak dikembalikan server.`,
          );
        }
        fileNames[key] = name;
      }
      return fileNames;
    },

    /**
     * Sisipkan suratSertifikasi / suratIzin ke entri final_kblis yang cocok dengan baris form.
     * Jika hanya ganti file (tanpa ubah kode/deskripsi/tr) belum ada entri di final_kblis, tambah payload update minimal.
     */
    patchFinalKbliEntriesForFormRow(row, patch) {
      let matched = 0;
      for (const item of this.final_kblis) {
        if (item.isDeleted) {
          continue;
        }
        if (row.id != null && item.id != null && item.id == row.id) {
          Object.assign(item, patch);
          matched++;
          continue;
        }
        if (
          row.id == null &&
          item.id == null &&
          item.kontraktorId &&
          item.kode === row.kode &&
          item.deskripsi === row.deskripsi
        ) {
          Object.assign(item, patch);
          matched++;
        }
      }
      if (matched === 0 && row.id != null) {
        this.final_kblis.push({
          id: row.id,
          kontraktorId: this.userData.kontraktorID,
          kode: row.kode,
          deskripsi: row.deskripsi,
          izin: null,
          sertifikasiStandar: null,
          tingkatResiko: row.tingkatResiko,
          isDeleted: false,
          isVerified: false,
          notes: null,
          suratSertifikasi: null,
          suratIzin: null,
          ...patch,
        });
      }
    },

    /**
     * API KBLI memakai suratSertifikasi / suratIzin saja — salin dari alias file*
     * jika ada, lalu hapus fileSertifikat & fileIzin agar tidak terkirim di POST.
     */
    normalizeKbliSuratPayloadFields() {
      const toNullIfEmpty = (v) =>
        v === undefined || v === null || v === "" ? null : v;
      for (const item of this.final_kblis) {
        item.suratSertifikasi = toNullIfEmpty(
          item.suratSertifikasi ?? item.fileSertifikat,
        );
        item.suratIzin = toNullIfEmpty(item.suratIzin ?? item.fileIzin);
        item.sertifikasiStandar = null;
        delete item.fileSertifikat;
        delete item.fileIzin;
      }
    },

    /**
     * Upload dokumen sertifikat/izin KBLI (cms/upload/file) paralel, lalu patch final_kblis
     * agar POST simpan sudah membawa nama file.
     */
    async uploadKbliDocumentsIntoFinalPayload() {
      if (!this.uploadFileService) {
        return;
      }
      const tasks = [];
      const meta = [];
      for (
        let rowIndex = 0;
        rowIndex < this.formValues.kblis.length;
        rowIndex++
      ) {
        const row = this.formValues.kblis[rowIndex];
        if (row.deleted || row.show === false) {
          continue;
        }
        const tr = row.tingkatResiko;
        const refSert = this.$refs.FileDokumenSertifikasi?.[rowIndex];
        const refIzin = this.$refs.FileDokumenIzin?.[rowIndex];
        if ((tr == 2 || tr == 3) && refSert?.files?.[0]) {
          tasks.push(this.uploadFileService.uploadFile(refSert.files[0]));
          meta.push({ row, kind: "sertifikat" });
        }
        if (tr == 4 && refIzin?.files?.[0]) {
          tasks.push(this.uploadFileService.uploadFile(refIzin.files[0]));
          meta.push({ row, kind: "izin" });
        }
      }
      if (tasks.length === 0) {
        return;
      }
      const resList = await Promise.all(tasks);
      for (let i = 0; i < resList.length; i++) {
        const name = this.filenameFromUploadResponse(resList[i]);
        if (!name) {
          throw new Error(
            "Upload dokumen KBLI gagal: server tidak mengembalikan nama file.",
          );
        }
        const { row, kind } = meta[i];
        const patch =
          kind === "sertifikat"
            ? { suratSertifikasi: name }
            : { suratIzin: name };
        this.patchFinalKbliEntriesForFormRow(row, patch);
      }
    },

    async simpanEditProfile(files, purposes) {
      let fileNames = {};
      try {
        const [kontraktorNames] = await Promise.all([
          this.uploadKontraktorDocumentsViaService(files, purposes),
          this.uploadKbliDocumentsIntoFinalPayload(),
        ]);
        fileNames = kontraktorNames;

        this.normalizeKbliSuratPayloadFields();

        // Gabungan data profil + delta KBLI (final_kblis) untuk POST; nama file hasil upload service.
        const bodyJsonProfile = {
          id: this.userData.kontraktorID,
          namaKontraktor: this.formValues.namaKontraktor,
          namaPjo: this.formValues.namaPjo,
          kompetensiPjo: this.formValues.kompetensiPjo,
          inisial: this.formValues.inisial,
          nib: this.formValues.nomorNIB != "" ? true : false,
          noNib: this.formValues.nomorNIB,
          iujp: this.formValues.klasifikasi == "Inti" ? true : false,
          noIujp: this.formValues.nomorIUJP,
          tglExpIujp:
            this.formValues.masaBerlakuIUJP != null &&
            this.formValues.masaBerlakuIUJP != ""
              ? moment(this.formValues.masaBerlakuIUJP).format("YYYY-MM-DD")
              : null,
          kblis: this.final_kblis,
          bidangUsahaGems: JSON.stringify(this.buildBidangsPayloadForApi()),
          noPengesahanPjo: this.formValues.nomorSuratPengesahan,
          tglSuratPengesahan:
            this.formValues.tanggalPengesahan != null &&
            this.formValues.tanggalPengesahan != ""
              ? moment(this.formValues.tanggalPengesahan).format("YYYY-MM-DD")
              : null,
          alamat: this.formValues.alamat,
          provinsi: this.formValues.provinsi,
          picEmail: this.formValues.emailPic,
          picPhone: this.formValues.hpPic,
          kualifikasiUsaha: parseInt(this.formValues.kualifikasiUsaha),
          ...fileNames,
        };

        console.log("body nya = ", bodyJsonProfile);

        const res = await axios.post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        this.isLoading = false;

        Swal.fire({
          title: "Edit Profile Sukses",
          text:
            res.data?.status?.message ??
            "Data Profile Perusahaan telah diperbarui!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          this.$router.back();
        });
      } catch (error) {
        this.isLoading = false;
        const msg =
          error.response?.data?.status?.message ??
          error.response?.data?.message ??
          error.message;
        util.showError(msg);
      }
    },

    async clickSimpan() {
      this.compareKBLIS();

      let validasiForm = this.validasiForm();
      let validasiFormKBLIs = this.validasiFormKBLIs();
      let validasiFileKBLIs = this.validasiFileKBLIs();
      let validasiBidangIUJP = this.validasiBidangIUJP();
      if (
        !validasiForm[0] ||
        !validasiFormKBLIs[0] ||
        !validasiFileKBLIs[0] ||
        !validasiBidangIUJP[0]
      ) {
        let message =
          "Formulir Anda memiliki kesalahan pada kolom berikut:\n\n";

        if (!validasiForm[0]) {
          validasiForm[1].forEach(
            (field, index) => (message += `${index + 1}. ${field}\n`),
          );
        }

        if (!validasiFormKBLIs[0]) {
          validasiFormKBLIs[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nKBLI :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }

        if (!validasiFileKBLIs[0]) {
          validasiFileKBLIs[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nFile KBLI :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }

        if (!validasiBidangIUJP[0]) {
          validasiBidangIUJP[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nBidang IUJP :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }
        alert(message);
      } else {
        const inisialOk = await this.validateInisialBeforeSubmit();
        if (!inisialOk) {
          alert(
            this.inisialDuplicateError ||
              "Inisial tidak valid atau sudah digunakan.",
          );
          return;
        }

        const confirmResult = await Swal.fire({
          title: "Konfirmasi Simpan",
          text: "Apakah Anda yakin ingin menyimpan perubahan profil ini?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#2563eb",
          cancelButtonColor: "#6b7280",
          confirmButtonText: "Ya, Simpan",
          cancelButtonText: "Batal",
          reverseButtons: true,
        });

        if (!confirmResult.isConfirmed) {
          return;
        }

        Swal.fire({
          title: "Mohon Tunggu",
          text: "Sedang mengunggah berkas dan menyimpan data profil...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const fileLogo = this.$refs.fileLogo?.files?.[0] || null;
        const fileDokumenPengesahan =
          this.$refs.fileDokumenPengesahan?.files?.[0] || null;
        const fileDokumenIUJP = this.$refs.fileDokumenIUJP?.files?.[0] || null;
        const fileDokumenNIB = this.$refs.fileDokumenNIB?.files?.[0] || null;
        let files = [];
        let purposes = [];

        if (fileLogo != null) {
          files.push(fileLogo);
          purposes.push("kontraktor");
        }
        if (fileDokumenPengesahan != null) {
          files.push(fileDokumenPengesahan);
          purposes.push("pengesahan");
        }
        if (fileDokumenIUJP != null) {
          files.push(fileDokumenIUJP);
          purposes.push("iujp");
        }
        if (fileDokumenNIB != null) {
          files.push(fileDokumenNIB);
          purposes.push("nib");
        }

        await this.simpanEditProfile(files, purposes);
      }
    },
    validasiForm() {
      let status = true;
      let kolom = [];
      if (this.formValues.namaKontraktor?.trim() == "") {
        status = status && false;
        kolom.push("Nama Kontraktor");
      }
      if (this.formValues.klasifikasi == "") {
        status = status && false;
        kolom.push("Klasifikasi");
      }
      if (
        this.formValues.kualifikasiUsaha == "" ||
        this.formValues.kualifikasiUsaha == null
      ) {
        status = status && false;
        kolom.push("Kualifikasi Usaha");
      }
      if (this.formValues.nomorNIB?.trim() == "") {
        status = status && false;
        kolom.push("Nomor NIB");
      }
      if (
        this.$refs.fileDokumenNIB.value == "" &&
        (this.kontraktor.fileNib == null || this.kontraktor.fileNib == "")
      ) {
        status = status && false;
        kolom.push("File Dokumen NIB");
      } else if (
        this.$refs.fileDokumenNIB.value == "" &&
        this.count_kbli_previous != this.formValues.kblis.length
      ) {
        status = status && false;
        kolom.push("File Dokumen NIB harus diperbarui");
      }
      if (this.wajibIUJP == true) {
        if (this.formValues.nomorIUJP?.trim() == "") {
          status = status && false;
          kolom.push("Nomor IUJP");
        }
        if (
          this.formValues.masaBerlakuIUJP == "" ||
          this.formValues.masaBerlakuIUJP == null
        ) {
          status = status && false;
          kolom.push("Masa Berlaku IUJP");
        }
        if (
          this.$refs.fileDokumenIUJP.value == "" &&
          (this.kontraktor.fileIujp == null || this.kontraktor.fileIujp == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen IUJP");
        } else if (
          this.$refs.fileDokumenIUJP.value == "" &&
          this.count_bidangs_previous != this.formValues.bidangs.length
        ) {
          status = status && false;
          kolom.push("File Dokumen IUJP harus diperbarui");
        }
      }
      return [status, kolom];
    },
    validasiFormKBLIs() {
      let status = true;
      let kolom = [];
      // if (this.wajibIUJP == true) {
      // }
      if (this.formValues.kblis.length == 0) {
        status = status && false;
        kolom.push("KBLI perlu ditambahkan");
      }
      this.formValues.kblis.forEach((item, index) => {
        if (item.tingkatResiko == "" || item.tingkatResiko == null) {
          status = status && false;
          kolom.push("Tingkat Resiko form KBLI ke-" + (index + 1));
        }
      });
      return [status, kolom];
    },
    validasiFileKBLIs() {
      let status = true;
      let kolom = [];

      this.formValues.kblis.forEach((item, index) => {
        if (
          this.$refs.FileDokumenSertifikasi[index].value == "" &&
          (item.tingkatResiko == 2 || item.tingkatResiko == 3) &&
          (item.fileSertifikat == null || item.fileSertifikat == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen Sertifikat form KBLI ke-" + (index + 1));
        }
        if (
          this.$refs.FileDokumenIzin[index].value == "" &&
          item.tingkatResiko == 4 &&
          (item.fileIzin == null || item.fileIzin == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen Izin form KBLI ke-" + (index + 1));
        }
      });
      return [status, kolom];
    },
    validasiFileKBLIsByTingkatResiko() {
      for (var h in this.formValues.kblis) {
        let uk = this.formValues.kblis[h];
        // this.$refs.FileDokumenIzin[uk.index].value;
        // this.$refs.FileDokumenSertifikasi[uk.index].value
        if (
          uk.tingkatResiko != null &&
          uk.tingkatResiko != 1 &&
          uk.tingkatResiko != ""
        ) {
          if (uk.tingkatResiko == 2 || uk.tingkatResiko == 3) {
            if (this.$refs.FileDokumenSertifikasi[h] != null) {
              if (
                !(
                  uk.fileSertifikat != null ||
                  this.$refs.FileDokumenSertifikasi[h].value != ""
                )
              ) {
                // console.log('kbli3')
                return false;
              }
            }
          }
          if (uk.tingkatResiko == 4) {
            // if(this.$refs.FileDokumenSertifikasi[h]!=null){
            //     if(!(uk.fileSertifikat!=null||this.$refs.FileDokumenSertifikasi[h].value!='')){
            //         // console.log('kbli4')
            //         return false;
            //     }
            // }
            if (this.$refs.FileDokumenIzin[h] != null) {
              if (
                !(
                  uk.fileIzin != null ||
                  this.$refs.FileDokumenIzin[h].value != ""
                )
              ) {
                // console.log('kbli5')
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    validasiBidangIUJP() {
      let status = true;
      let kolom = [];
      if (this.wajibIUJP == true) {
        console.log(this.formValues.bidangs);
        if (this.formValues.bidangs.length == 0) {
          status = status && false;
          kolom.push("Bidang Dan Sub Bidang perlu ditambahkan");
        } else {
          this.formValues.bidangs.forEach((item, index) => {
            if (item.NMBIDANG == "") {
              status = status && false;
              kolom.push(`Bidang form Bidang IUJP ke-${index + 1}`);
            }
            if (item.SUBBIDANG == "") {
              status = status && false;
              kolom.push(`Sub Bidang form Bidang IUJP ke-${index + 1}`);
            }
          });
        }
      }
      return [status, kolom];
    },

    /** "-" di form jadi null untuk API */
    kbliDashToNull(value) {
      return value == "-" ? null : value;
    },

    /**
     * Menyiapkan data KBLI untuk POST simpan profil.
     *
     * | Properti        | Peran |
     * |-----------------|--------|
     * | formValues.kblis | Baris di UI (bisa baru tanpa id, atau lama + flag deleted) |
     * | temp_kblis       | Baseline KBLI dari GET detail (tidak ditimpa snapshot ditolak) — dipakai compareKBLIS |
     * | final_kblis      | Yang dikirim ke API: tambah / ubah / hapus (isDeleted); nama file KBLI di-patch sebelum POST |
     * | added_kblis      | Baris baru (tanpa id) — dipakai hapusKBLI untuk sinkron saat user batalkan draft |
     * | deleted_kblis    | Diisi di hapusKBLI() untuk baris lama yang user hapus |
     */
    compareKBLIS() {
      this.resetKbliSubmitBuffers();

      for (
        let rowIndex = 0;
        rowIndex < this.formValues.kblis.length;
        rowIndex++
      ) {
        const current = this.formValues.kblis[rowIndex];
        this.appendNewKbliRowForApi(current);
        this.mergeExistingKbliWithSnapshot(current, rowIndex);
      }

      /**
       * Isi nama file surat dari form (termasuk snapshot dataChanges / ditolak)
       * bila belum ada di final_kblis — hindari file hilang saat tidak ada delta
       * vs temp_kblis atau tanpa upload ulang.
       */
      this.augmentFinalKbliWithSuratFilesFromForm();

      this.appendSoftDeletedKbliRowsForApi();
      console.log("final: ", this.final_kblis);
    },

    resetKbliSubmitBuffers() {
      this.final_kblis = [];
      this.added_kblis = [];
    },

    /** Baris baru (belum punya id): satu payload insert + metadata untuk upload nanti. */
    appendNewKbliRowForApi(current) {
      if (current.deleted || current.show === false) {
        return;
      }
      if (current.id != null) {
        return;
      }
      const izin = this.kbliDashToNull(current.izin);
      const toNullIfEmpty = (v) =>
        v === undefined || v === null || v === "" ? null : v;

      this.final_kblis.push({
        kontraktorId: this.userData.kontraktorID,
        kode: current.kode,
        deskripsi: current.deskripsi,
        izin,
        sertifikasiStandar: null,
        tingkatResiko: current.tingkatResiko,
        isVerified: false,
        notes: null,
        suratSertifikasi: toNullIfEmpty(
          current.fileSertifikat ?? current.suratSertifikasi,
        ),
        suratIzin: toNullIfEmpty(current.fileIzin ?? current.suratIzin),
      });

      this.added_kblis.push({
        kode: current.kode,
        deskripsi: current.deskripsi,
        izin,
        sertifikasiStandar: null,
        tingkatResiko: current.tingkatResiko,
        req_izin: current.tingkatResiko == 4,
        req_sertifikasi: false,
        isVerified: false,
        notes: null,
      });
    },

    /** Cocokkan baris yang punya id dengan snapshot baseline (GET detail); jika berubah → payload update ke API. */
    mergeExistingKbliWithSnapshot(current, rowIndex) {
      console.log({ current, rowIndex });

      const toNullIfEmpty = (v) =>
        v === undefined || v === null || v === "" ? null : v;

      if (current.deleted || current.show === false) {
        return;
      }

      let matchedSnapshot = false;
      for (let s = 0; s < this.temp_kblis.length; s++) {
        const snapshot = this.temp_kblis[s];
        if (String(snapshot.id ?? "") !== String(current.id ?? "")) {
          continue;
        }
        matchedSnapshot = true;

        const trSnap = Number(snapshot.tingkatResiko);
        const trCur = Number(current.tingkatResiko);
        const snapCert = snapshot.fileSertifikat ?? null;
        const snapIzin = snapshot.fileIzin ?? null;
        const curCert = current.fileSertifikat ?? null;
        const curIzin = current.fileIzin ?? null;

        const hasFieldChange =
          snapshot.kode != current.kode ||
          snapshot.deskripsi != current.deskripsi ||
          trSnap !== trCur;
        const hasFileChange = snapCert !== curCert || snapIzin !== curIzin;

        if (
          (hasFieldChange || hasFileChange) &&
          current.show == true &&
          current.id != null
        ) {
          this.final_kblis.push({
            id: current.id,
            kontraktorId: this.userData.kontraktorID,
            kode: current.kode,
            deskripsi: current.deskripsi,
            izin: null,
            sertifikasiStandar: null,
            tingkatResiko: current.tingkatResiko,
            isDeleted: false,
            isVerified: false,
            notes: null,
            suratSertifikasi: toNullIfEmpty(
              current.fileSertifikat ?? current.suratSertifikasi,
            ),
            suratIzin: toNullIfEmpty(current.fileIzin ?? current.suratIzin),
          });
        }

        break;
      }

      /**
       * Baseline GET detail kosong / tidak punya baris dengan id ini (mis. hanya
       * isian ditolak) → tetap kirim payload update agar KBLI tidak hilang saat simpan.
       */
      if (
        !matchedSnapshot &&
        current.id != null &&
        current.show === true &&
        current.deleted !== true
      ) {
        this.final_kblis.push({
          id: current.id,
          kontraktorId: this.userData.kontraktorID,
          kode: current.kode,
          deskripsi: current.deskripsi,
          izin: null,
          sertifikasiStandar: null,
          tingkatResiko: current.tingkatResiko,
          isDeleted: false,
          isVerified: false,
          notes: null,
          suratSertifikasi: toNullIfEmpty(
            current.fileSertifikat ?? current.suratSertifikasi,
          ),
          suratIzin: toNullIfEmpty(current.fileIzin ?? current.suratIzin),
        });
      }
    },

    kbliToNullIfEmpty(v) {
      return v === undefined || v === null || v === "" ? null : v;
    },

    /**
     * Pastikan setiap baris KBLI tampil di payload punya suratSertifikasi / suratIzin
     * dari nilai form (fileSertifikat / fileIzin), termasuk bila compare tidak
     * membuat entri karena tidak ada perubahan vs baseline.
     */
    augmentFinalKbliWithSuratFilesFromForm() {
      const toNull = (v) => this.kbliToNullIfEmpty(v);

      for (const row of this.formValues.kblis) {
        if (row.deleted || row.show === false) {
          continue;
        }

        const cert = toNull(row.fileSertifikat ?? row.suratSertifikasi);
        const izinFile = toNull(row.fileIzin ?? row.suratIzin);

        if (row.id != null) {
          let item = this.final_kblis.find(
            (e) => !e.isDeleted && String(e.id ?? "") === String(row.id ?? ""),
          );
          if (!item) {
            this.final_kblis.push({
              id: row.id,
              kontraktorId: this.userData.kontraktorID,
              kode: row.kode,
              deskripsi: row.deskripsi,
              izin: null,
              sertifikasiStandar: null,
              tingkatResiko: row.tingkatResiko,
              isDeleted: false,
              isVerified: false,
              notes: null,
              suratSertifikasi: cert,
              suratIzin: izinFile,
            });
          } else {
            if (!toNull(item.suratSertifikasi) && cert) {
              item.suratSertifikasi = cert;
            }
            if (!toNull(item.suratIzin) && izinFile) {
              item.suratIzin = izinFile;
            }
          }
          continue;
        }

        const item = this.final_kblis.find(
          (e) =>
            !e.isDeleted &&
            e.id == null &&
            e.kontraktorId === this.userData.kontraktorID &&
            String(e.kode ?? "") === String(row.kode ?? "") &&
            String(e.deskripsi ?? "") === String(row.deskripsi ?? "") &&
            Number(e.tingkatResiko) === Number(row.tingkatResiko),
        );
        if (item) {
          if (!toNull(item.suratSertifikasi) && cert) {
            item.suratSertifikasi = cert;
          }
          if (!toNull(item.suratIzin) && izinFile) {
            item.suratIzin = izinFile;
          }
        }
      }
    },

    /** Baris yang user hapus (sudah ada id) → kirim sebagai soft delete ke API. */
    appendSoftDeletedKbliRowsForApi() {
      for (let j = 0; j < this.deleted_kblis.length; j++) {
        const del = this.deleted_kblis[j];
        this.final_kblis.push({
          id: del.id,
          kontraktorId: this.userData.kontraktorID,
          kode: del.kode,
          deskripsi: del.deskripsi,
          izin: this.kbliDashToNull(del.izin),
          sertifikasiStandar: null,
          tingkatResiko: del.tingkatResiko,
          isDeleted: true,
          isVerified: false,
          notes: null,
          suratSertifikasi: null,
          suratIzin: null,
        });
      }
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "nib") {
        file = this.$refs.fileDokumenNIB.files[0];
      } else if (refFile == "iujp") {
        file = this.$refs.fileDokumenIUJP.files[0];
      } else if (refFile == "suratPengesahan") {
        file = this.$refs.fileDokumenPengesahan.files[0];
      }

      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          if (refFile == "nib") {
            this.validasiFile.typeNib = true;
            this.validasiFile.sizeNib = false;
            this.$refs.fileDokumenNIB.value = "";
          } else if (refFile == "iujp") {
            this.validasiFile.typeIujp = true;
            this.validasiFile.sizeIujp = false;
            this.$refs.fileDokumenIUJP.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typeSuratPengesahan = true;
            this.validasiFile.sizeSuratPengesahan = false;
            this.$refs.fileDokumenPengesahan.value = "";
          }
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "nib") {
            this.validasiFile.typeNib = false;
            this.validasiFile.sizeNib = true;
            this.$refs.fileDokumenNIB.value = "";
          } else if (refFile == "iujp") {
            this.validasiFile.typeIujp = false;
            this.validasiFile.sizeIujp = true;
            this.$refs.fileDokumenIUJP.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typeSuratPengesahan = false;
            this.validasiFile.sizeSuratPengesahan = true;
            this.$refs.fileDokumenPengesahan.value = "";
          }
          return;
        }

        // Reset error messages if the file is valid
        if (refFile == "nib") {
          this.validasiFile.typeNib = false;
          this.validasiFile.sizeNib = false;
        } else if (refFile == "iujp") {
          this.validasiFile.typeIujp = false;
          this.validasiFile.sizeIujp = false;
        } else if (refFile == "suratPengesahan") {
          this.validasiFile.typeSuratPengesahan = false;
          this.validasiFile.sizeSuratPengesahan = false;
        }

        // Handle the valid file as needed (e.g., store the file)
        // console.log('Valid file:', file);
      }
    },
    handleChangeFileKBLI(index, refFile) {
      // console.log('w',this.$refs.FileDokumenSertifikasi);
      // console.log('x',index);
      // console.log('y',this.formValues.kblis);

      let file = null;
      if (refFile == "sertifikasi") {
        if (this.$refs.FileDokumenSertifikasi[index] != null) {
          file = this.$refs.FileDokumenSertifikasi[index].files[0];
        }
      } else if (refFile == "izin") {
        if (this.$refs.FileDokumenIzin[index] != null) {
          file = this.$refs.FileDokumenIzin[index].files[0];
        }
      }

      if (file) {
        if (file.type !== "application/pdf") {
          if (refFile == "sertifikasi") {
            this.formValues.kblis[index].typeSertifikasi = true;
            this.formValues.kblis[index].sizeSertifikasi = false;
          } else if (refFile == "izin") {
            this.formValues.kblis[index].typeIzin = true;
            this.formValues.kblis[index].sizeIzin = false;
          }
          return;
        }
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "sertifikasi") {
            this.formValues.kblis[index].typeSertifikasi = false;
            this.formValues.kblis[index].sizeSertifikasi = true;
          } else if (refFile == "izin") {
            this.formValues.kblis[index].typeIzin = false;
            this.formValues.kblis[index].sizeIzin = true;
          }
          return;
        }

        if (refFile == "sertifikasi") {
          this.formValues.kblis[index].typeSertifikasi = false;
          this.formValues.kblis[index].sizeSertifikasi = false;
          this.formValues.kblis[index].sertifikasiStandar = "Terverifikasi";
        } else if (refFile == "izin") {
          this.formValues.kblis[index].typeIzin = false;
          this.formValues.kblis[index].sizeIzin = false;
        }
      }
      // console.log(this.formValues.kblis[index]);
      // console.log(this.formValues.kblis)
    },
    downloadFile(filename) {
      window.open(url_download + filename, "_blank");
    },
  },
};
</script>
